var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('C保有不動産Edit',{attrs:{"is法人":false}})}
var staticRenderFns = []

export { render, staticRenderFns }